import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './rootReducer';
import { configureStore } from '@reduxjs/toolkit';
import { UserPasswordlessManager } from 'shared/oidc/passwordLessUserManager';

const persistConfig = {
  key: 'state',
  storage,
  whitelist: [
    'snswOidc',
    'plantItemLicenceTypes',
    'form',
    'profile',
    'serviceActivation',
    'applicantDetails',
    'holderDetails',
    'application',
    'plantItems',
    'referenceData',
    'pdfLink',
    'declaration',
    'privacyCollection',
    'plantDesignApplication',
    'plantDesignReferenceData',
    'plantDesignApplicantDetails',
    'plantDesign',
    'plantDesignDrawingAndTech',
    'plantDesignVerifier',
    'plantDesignDeclaration',
    'passwordlessOidc',
    'plantDesignForm',
    'plantDesignHolderDetails',
    'plantDesignLicenceTypes',
    'plantItemRenewalApplicantDetails',
    'plantItemRenewalDeclaration',
    'renewalItems',
    'plantItemRenewalPayment',
  ],
  keyPrefix: `pid:`,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production' || process.env.REACT_APP_ENABLE_REDUXT_DEVTOOL === 'true',
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

const persistor = persistStore(store);

UserPasswordlessManager.init(store);

export { store, persistor };
